

let language = {

    "STORE_PRODUCT_SETTING_BINDING_CONFIG_PRODUCT_TITLE": "Select the Etsy Products You Want to Link:",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_DROPDOWN_PLACEHOLDER": "Select product",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_SEARCH_PLACEHOLDER": "Esty Product ID",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_LOADING_MORE": "Load More",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_LOADING": "Loading...",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_NO_SELECTION": "Please select Etsy products from the list.",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_VIEW_STORE": "View Etsy Store Products",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_OVERRIDE_PRICE": "Override current Etsy prices with QPMN pricing.",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_OVERRIDE_IMAGE": "Override current Etsy product image with QPMN product images.",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_OVERRIDE_BASEINFO": "Override current Etsy product Base Info with QPMN product Base Info.",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_NEXT": "GO PRODUCT",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_SAVE": "SAVE",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_LINKED": "Linked",
    
    "STORE_PRODUCT_SETTING_BINDING_LIST_FETCHING_ERROR_TITLE": "List fetching error",
    "STORE_PRODUCT_SETTING_BINDING_LIST_FETCHING_ERROR_CONTENT": "List fetching error",
    "STORE_PRODUCT_SETTING_BINDING_TOKEN_EXPIRED_ERROR_1101173002": "The token has expired. Please click ok to reauthorize",
    "STORE_PRODUCT_SETTING_BINDING_TOKEN_EXPIRED_BUTTON": "authorization",
    "STORE_PRODUCT_SETTING_BINDING_TOKEN_EXPIRED_ERROR_1101173001": "connection timeout",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_LOOKUP_FAILED_TITLE": "Product lookup failed",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_LOOKUP_FAILED_CONTENT": "Product lookup failed",
    "STORE_PRODUCT_SETTING_BINDING_AUTHORIZATION_BUTTON": "authorization",
    "STORE_PRODUCT_SETTING_BINDING_CANCEL_BUTTON": "cancel",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_INFO_SYNC_TITLE": "Product Information Synchronization",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_INFO_SYNC_CLOSE": "×",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_INFO_SYNC_MESSAGE": "You have selected to sync and override the following product information. Please confirm.",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_INFO_SYNC_PRICE": "• Price",
    "STORE_PRODUCT_SETTING_BINDING_PRODUCT_INFO_SYNC_IMAGE": "• Product Image",
    "STORE_PRODUCT_SETTING_BINDING_CONFIRM_BUTTON": "CONFIRM"


    
};


export { language }